<template>
  <CardComponent>
    <div class="stepper-container">
      <template v-for="(step, index) in steps">
        <div class="stepper-step" :class="{completed: index < value, inactive: inactive}" :key="'step' + index" @click="changeStep(index)">
          <span class="stepper-step-icon">
            <component
              :is="index < value ? 'PipelineCircleFilledIcon' : 'PipelineCircleOutlinedIcon'"
              :small="index === 0"/>
          </span>
          <div class="stepper-step-text" :class="{completed: index < value}" @click="changeStep(index)">{{ step }}</div>
        </div>
        <div class="stepper-divider" :class="{completed: index < value, last: index === value - 1}" :key="'divider' + index"
             v-if="index < steps.length - 1"></div>
      </template>
    </div>
  </CardComponent>
</template>

<script>
import CardComponent from "@/components/form/CardComponent";
import PipelineCircleFilledIcon from "@/components/icons/PipelineCircleFilledIcon";
import PipelineCircleOutlinedIcon from "@/components/icons/PipelineCircleOutlinedIcon";

export default {
  name: "PipelineComponent",
  components: {PipelineCircleOutlinedIcon, PipelineCircleFilledIcon, CardComponent},
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    value: {
      type: Number,
      default: 0
    },
    inactive: {
      type: Boolean,
      default: false
    }
  },
  setup(_, {emit}) {
    function changeStep(stepIndex) {
      if(!_.inactive)
        emit('input', stepIndex + 1)
    }

    return {changeStep}
  }
}
</script>

<style scoped lang="scss">

.stepper-container {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  padding-left: 32px;
  padding-right: 32px;
}

// Single step
.stepper-step {
  position: relative;
  cursor: pointer;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  
  &.inactive{
    cursor: default;
  }

  // Stepper divider for continuous line
  &::before {
    position: absolute;
    top: 38.5px;
    left: 0;
    right: 0;
    content: '';
    box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
    background-color: map-get($material-light, 'dividers');
    height: 3px;
  }

  &.completed {
    &::before {
      background-color: map-get($pink, 'darken-1');
    }
  }

  // First step: Remove left line
  &:first-child {
    &::before {
      left: 50%;
    }
  }

  // Last step: Remove right line
  &:last-child {
    &::before {
      right: 50%;
    }
  }

  .stepper-step-icon {
    position: relative;
    background-color: transparent;
    border-color: transparent;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    height: 66px;
    min-width: 66px;
  }

  .stepper-step-text {
    color: map-get($material-light, 'dividers');
    font-weight: 500;
    line-height: 22px;

    &.completed {
      color: map-get($pink, 'darken-1');
    }
  }
}

.stepper-divider {
  box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  background-color: map-get($material-light, 'dividers');
  align-self: flex-start;
  flex: 1 1 auto;
  margin-top: 38.5px;
  transition: inherit;
  max-width: 100%;
  min-width: 32px;
  height: 3px;

  &.completed {
    background-color: map-get($pink, 'darken-1');

    // Gradient for visual change of completed and open steps
    &.last {
      background: -moz-linear-gradient(left, map-get($pink, 'darken-1') 0%, map-get($material-light, 'dividers') 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(left, map-get($pink, 'darken-1') 0%, map-get($material-light, 'dividers') 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to right, map-get($pink, 'darken-1') 0%, map-get($material-light, 'dividers') 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    }
  }
}

.theme--marketplace{
  .stepper-step{
    &.completed {
      &::before {
        background-color: map-get($material-light, 'dividers');
      }
    }

    .stepper-step-text {
      color: inherit;
    }      
  }

  .stepper-divider{
    &.completed {
      background-color: map-get($material-light, 'dividers');

      // Gradient for visual change of completed and open steps
      &.last {
        background: -moz-linear-gradient(left, map-get($material-light, 'dividers') 0%, map-get($material-light, 'dividers') 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(left, map-get($material-light, 'dividers') 0%, map-get($material-light, 'dividers') 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to right, map-get($material-light, 'dividers') 0%, map-get($material-light, 'dividers') 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      }
    }    
  }
}

</style>

<!-- the icon is not in scope -->
<style lang="scss">
  .theme--marketplace{
    .stepper-step{
      .stepper-step-icon {
        .pipelinecirclefilledicon{
          .a{
              fill: map-get($material-light, 'dividers');
          }        
        }
      }
    }
  }  
</style>


